import { HttpService } from "./http.service";
import { AuthService } from './auth.service';
import { LocaleService } from './locale.service';
import { DataState } from './data-state';
import { ModalService } from './modal.service';
export var APPLICATON_NAME = process.env.REACT_APP_NAME;
export var Container;
export function createContainer(applicationSetup) {
    var http = new HttpService();
    var auth = new AuthService(http);
    var locale = new LocaleService(http);
    var modal = new ModalService();
    Container = {
        http: http, auth: auth, applicationSetup: applicationSetup, locale: locale, modal: modal,
        createDataStateService: function (dataState) {
            return new DataState(locale, dataState);
        }
    };
}
//# sourceMappingURL=di.js.map